// Takes in a Date (from the past) and returns a string
// showing how many days ago the date was
// eg: return => '4 days ago'
export const convertDateToShowHowManyDaysAgoSinceToday = (dateToCalculate) => {
  const diffTime = Math.abs(new Date() - new Date(dateToCalculate));
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const lastLogin = `${diffDays} day${diffDays > 1 ? 's' : '' } ago`;
  return lastLogin;
};

export const sum = arr => {
  const reducer = (previousValue, currentValue) => previousValue + currentValue;
  return arr.reduce(reducer);
};

export const convertArrayToBoolean = projectData => {
  projectData.allProjects.forEach(project => {
    if (project.adminWeeklyReport.length > 0) {
      project.adminWeeklyReport = true;
    } else {
      project.adminWeeklyReport = false;
    }
  });
  return projectData;
}

export const convertBooleanValueToString = projectData => {
  projectData.allProjects.forEach(project => {
    for (let key of Object.keys(project)) {
      if (project[key] && project[key].toString().toLowerCase() === 'true') {
        project[key] = 'True';
      }
    }
  });
  return projectData;
};

export const countReportTemplates = projectData => {
  // Create a new array with updated project objects
  const updatedProjects = projectData.allProjects.map(project => {
    // Progress Claim Report
    const progressClaimRegex = /Progress Claim/gi;
    const progressClaimCount = project.reports.filter(report => report.name.match(progressClaimRegex)).length;

    // ITP Report
    const ITPRegex = /ITP/g;
    const ITPCount = project.reports.filter(report => report.name.match(ITPRegex)).length;

    // Packing List Report
    const packingListRegex = /Packing List/gi;
    const packingListCount = project.reports.filter(report => report.name.match(packingListRegex)).length;

    // Defect Report
    const defectRegex = /Defect/gi;
    const defectCount = project.reports.filter(report => report.name.match(defectRegex)).length;

    // Return a new object with the original project properties and the new counts
    return {
      ...project,
      numberOfProgressClaimReportAdminCreated: progressClaimCount,
      numberOfITPReportAdminCreated: ITPCount,
      numberOfPackingListReportAdminCreated: packingListCount,
      numberOfDefectReportAdminCreated: defectCount
    };
  });

  // Return the updated project data
  return {
    ...projectData,
    allProjects: updatedProjects
  };
};

// Expects a new Date input and a range
// Prepends a 0 to singular month or days
// Return value is a string eg: '2021-05-02'
export const formatDateForQuery = (todaysDate, rangeToFormat) => {
  let dateToFormat;
  if (rangeToFormat === 'today') {
    dateToFormat = new Date(todaysDate.getFullYear(), todaysDate.getMonth(), todaysDate.getDate());
  }
  if (rangeToFormat === 'lastWeek') {
    dateToFormat = new Date(todaysDate.getFullYear(), todaysDate.getMonth(), todaysDate.getDate() - 7);
  }
  if (rangeToFormat === 'lastMonth') {
    dateToFormat = new Date(todaysDate.getFullYear(), todaysDate.getMonth(), todaysDate.getDate() - 30);;
  }
  let monthWithLeadingZero = dateToFormat.getMonth() + 1;
  let dayWithLeadingZero = dateToFormat.getDate();

  if ((dateToFormat.getMonth() + 1) < 10) {
    monthWithLeadingZero = `0${dateToFormat.getMonth() + 1}`;
  }
  if (dateToFormat.getDate() < 10) {
    dayWithLeadingZero = `0${dateToFormat.getDate()}`;
  }
  dateToFormat = `${dateToFormat.getFullYear()}-${monthWithLeadingZero}-${dayWithLeadingZero}`;
  return dateToFormat;
};

export const formatProjectStartAndEndDate = (projectData) => {
  projectData.allProjects.forEach(project => {
    if (!project.start_date && !project.end_date) {
      return projectData;
    }
    project.start_date = formatDateForQuery(new Date(project.start_date), 'today');
    project.end_date = formatDateForQuery(new Date(project.end_date), 'today');
  });
  return projectData;
};

export const cleanProjectDataForFrontEnd = projectData => {
  projectData = countReportTemplates(projectData);
  projectData = convertArrayToBoolean(projectData);
  projectData = convertBooleanValueToString(projectData);
  projectData = formatProjectStartAndEndDate(projectData);
  return projectData;
};
